
// Components
import Button, { BUTTON_TYPES } from "../../../components/atoms/button";
import { EditOutlined, DeleteOutlined } from "../../../components/atoms/icon";
// Styles
import styles from "../country.module.scss";
const createColumns = ({ onEdit, onDelete,  }) => {
  return [
    {
      title: <span style={{ color: "#cf9c46" }}>Country Name</span>,
      sorter: true,
      dataIndex: 'countryName',
      render: (text, countryDetail) => {
        return `${countryDetail.countryName}`;
      },
    },

    {
      title: <span style={{ color: "#cf9c46" }}>Country Language</span>,
      sorter: true,
      dataIndex: 'countryLanguage',
      render: (text, countryDetail) => {
        return `${countryDetail.countryLanguage}`;
      },
    },
    {
      // title: "Amount Position",
      title: <span style={{ color: "#cf9c46" }}>Amount Position</span>,
      sorter: true,
      dataIndex: 'amountPosition',
      render: (text, countryDetail) => {
        console.log(countryDetail)
        return `${countryDetail.position}`;
      },
    },
    {
      // title: "Country Currency",
      title: <span style={{ color: "#cf9c46" }}>Country Currency</span>,
      sorter: true,
      dataIndex: 'countryCurrency',
      render: (text, countryDetail) => {
        return `${countryDetail.currency}`;
      },
    },
    {
      // title: "Vat Tax",
      title: <span style={{ color: "#cf9c46" }}>Vat Tax</span>,
      sorter: true,
      dataIndex: 'vatTax',
      render: (text, countryDetail) => {
        return `${countryDetail.countryVatPercent}`;
      },
    },
    {
      title: <span style={{ color: "#cf9c46" }}>Goods Tax</span>,
      // title: "Goods Tax",
      sorter: true,
      dataIndex: 'goodTax',
      render: (text, countryDetail) => {
        return countryDetail.countryGoodPercent;
      },
    },
    
    {
      // title: "Actions",
      title: <span style={{ color: "#cf9c46" }}>Actions</span>,
      render: (text, businessAccountDetails) => {
        return (
          <>
            <Button
              type={BUTTON_TYPES.LINK}
              onClick={(event) => {
                onEdit(businessAccountDetails);
              }}
              className={styles.icon}
            >
              <EditOutlined />
            </Button>
            <Button
              disabled
              type={BUTTON_TYPES.LINK}
              onClick={(event) => {
                onDelete(businessAccountDetails);
              }}
              className={`${styles.icon} ${styles.iconDanger}`}
            >
              <DeleteOutlined />
            </Button>
          </>
        );
      },
    },
  ];
};

export { createColumns };
